import { useUserTableStore } from '../filters.store';

export const useFilters = () => {
  const { handleToggleFiltersCard, appliedFiltersCount, isFiltersCardOpen } =
    useUserTableStore();

  return {
    handleToggleFiltersCard,
    isFiltersCardOpen,
    appliedFiltersCount,
  };
};
